import classnames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormField, { STYLE } from "components/FormField";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import { Email, ModalDeleteIcon, Role } from "components/assets/Icons";
import { accountState, rolesList, teamMembers } from "actions/members";
import Dropdown, { SIZE } from "components/Dropdown";
import userProfile from "services/user.profile";
import { createList } from "../../utils";

import styles from "./Modals.module.scss";

export const ModalAdd = ({ data, setShowModal }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState({
    email: data?.email,
    role: { title: "", value: "" },
    id: data?.id,
  });
  const [roles, setRoles] = useState([]);
  const [formError, setFormError] = useState("");
  const [disabled, setDisabled] = useState(false);

  const employees = useSelector((state) => state.members);

  useEffect(() => {
    dispatch(rolesList);
  }, [dispatch]);

  useEffect(() => {
    setRoles(createList(employees?.roles, "name"));
  }, [employees]);

  const validate = (values) => {
    const regex =
      /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return !regex.test(values.email) && "Please, enter a valid email";
  };

  useEffect(() => {
    if (value.role.title === "" || value.email === "") {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [value.role.title, value.email]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    validate(value) && setFormError(validate(value));

    const data = {
      email: value.email,
      role: value.role.title,
      id: value.id,
    };

    formError === "" &&
      userProfile.accountCreate(data).then(
        (response) => {
          dispatch(accountState(value.id));
          setTimeout(() => setShowModal(false), 500);
        },
        ({ response }) => {
          const message = response?.data?.error;
          setFormError(message);
        }
      );
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>Create Account</h2>
      <p className={styles.description}>
        If you create an account, the owner of the email will receive a link to
        register.
      </p>
      <form className={styles.form} action="submit" onSubmit={handleOnSubmit}>
        <Dropdown
          list={roles}
          label="Role"
          className={styles.dropdown}
          icon={<Role />}
          value={value}
          setValue={setValue}
          keyValue="role"
          size={SIZE.MIDDLE}
        />
        <FormField
          labelText="Email"
          value={value.email}
          icon={<Email />}
          style={STYLE.MODAL}
          onChange={(e) => {
            setValue({ ...value, email: e.target.value });
            setFormError("");
          }}
          error={formError}
          className={formError !== "" ? styles.error : ""}
        />

        <div className={styles.group}>
          <p
            className={classnames(
              styles.error_message,
              formError !== "" && styles.active
            )}
          >
            {formError}
          </p>

          <Button
            size={VIEW.MIDDLE}
            color={COLOR.LIGHT}
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button size={VIEW.MIDDLE} type="submit" disabled={disabled}>
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export const ModalDelete = ({ data, setShowModal }) => {
  const dispatch = useDispatch();

  const handleOnClick = (e) => {
    e.preventDefault();

    userProfile.deleteMemberAccount(data.id).then(
      (res) => {
        dispatch(accountState(data.id));
        dispatch(teamMembers);
      },
      ({ response }) => {
        console.error("Member action error:", response);
      }
    );

    setTimeout(() => setShowModal(false), 500);
  };

  return (
    <div className={classnames(styles.content, styles.delete_content)}>
      <ModalDeleteIcon />
      <h2 className={styles.title}>Delete Account</h2>
      <p className={styles.description}>
        Do you really want to delete this account? This process cannot be
        undone.
      </p>
      <div className={styles.group}>
        <Button
          size={VIEW.MIDDLE}
          color={COLOR.LIGHT}
          onClick={() => setShowModal(false)}
        >
          Cancel
        </Button>
        <Button size={VIEW.MIDDLE} onClick={handleOnClick}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export const ModalChangeState = ({
  data,
  setShowModal,
  personalInfo,
  setPersonalInfo,
}) => {
  const dispatch = useDispatch();

  const handleOnClick = (e) => {
    e.preventDefault();

    userProfile.changeProfileMember(data.id, { is_active: !data.status }).then(
      (res) => {
        dispatch(teamMembers);
        setPersonalInfo({ ...personalInfo, is_active: !data.status });
      },
      ({ response }) => {
        console.error("Member action error:", response);
      }
    );

    setTimeout(() => setShowModal(false), 500);
  };

  return (
    <div className={classnames(styles.content, styles.delete_content)}>
      <ModalDeleteIcon />
      <h2 className={styles.title}>Deactivate Team Member</h2>
      <p className={styles.description}>
        Do you really want to deactivate this team member? This process cannot
        be undone.
      </p>
      <div className={styles.group}>
        <Button
          size={VIEW.MIDDLE}
          color={COLOR.LIGHT}
          onClick={() => setShowModal(false)}
        >
          Cancel
        </Button>
        <Button size={VIEW.MIDDLE} onClick={handleOnClick}>
          Deactivate
        </Button>
      </div>
    </div>
  );
};
